import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  width: "800",
  height: "800",
  viewBox: "0 0 512 512"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M423.795 31.763H88.205C39.363 31.763 0 71.571 0 119.966v192.679c0 48.711 39.699 88.205 88.205 88.205h54.841v18.531c0 10.656 8.638 19.292 19.292 19.292h84.429v22.253c0 17.109 20.595 25.661 32.752 13.821l83.601-81.417c7.765-7.561 7.783-20.063 0-27.643l-83.601-81.416c-12.196-11.883-32.752-3.204-32.752 13.821v22.251h-84.429c-10.656 0-19.292 8.638-19.292 19.292v18.533H88.205c-11.198 0-21.458-4.072-29.396-10.802l140.826-129.077c58.265 38.135 67.367 29.69 112.731 0l140.826 129.077c-7.938 6.73-18.198 10.802-29.396 10.802h-8.808c-11.785 0-21.339 9.554-21.339 21.339s9.554 21.34 21.339 21.34h8.808c48.451.003 88.204-39.441 88.204-88.202V119.966c0-48.49-39.451-88.203-88.205-88.203zM42.679 304.258V119.966c0-1.44.075-2.862.206-4.268l119.899 78.474L42.679 304.258zm223.605-106.814a18.773 18.773 0 0 1-20.567-.001L66.347 80.046a45.242 45.242 0 0 1 21.857-5.604c364.554 0 343.118-2.273 357.449 5.604L266.284 197.444zm203.037 106.814L349.215 194.174l119.9-78.475c.131 1.406.206 2.828.206 4.268v184.291z",
  style: {"fill":"currentColor"}
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }